package com.iregained.site.components.sections.error

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.s

val NotFoundHelpfulLinkStyle = CssStyle {
    val palette = colorMode.toSitePalette()

    base {
        Modifier.color(palette.custom.darkText) // Assuming standard text color
            .textDecorationLine(TextDecorationLine.Underline)
            .fontWeight(com.varabyte.kobweb.compose.css.FontWeight.Medium).transition(Transition.of("transform", 0.3.s))
    }
    hover {
        Modifier.color(palette.brand.primary) // Highlights on hover
    }
}